export default __webpack_public_path__ + "static/Hazard_Suit_Hat-9bd571b1a656417d18a1a2c1e9c1d438.png";